import { engagementReachConfig } from '../engagementReach';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const engagementReachMVConfig = {
    ...engagementReachConfig,
    id: 'engagement_on_reach',
    size: SIZE_FULL,
    orientation: ORIENTATION_VERTICAL,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
